import { Tooltip } from "antd";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import addEelement from "../../../../assets/img/icons/table/addEelem.svg";
import {
  openCreatePopOver,
  openReellePopup,
} from "../../../../data/slices/elements";
import { handleHoverStatus } from "../../../../data/slices/layout";
import { openModal } from "../../../../data/slices/modals";
import useClickOutside from "../../../../hooks/useCloseOutside";

function HoverCell({ category, isHovered, dataIndex, isPlancompta }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const refCell = useRef(null);

  const specialLabel =
    category?.isSpecial === 0 ? "" : category?.isSpecial ? "Spéciale" : "";

  const handleOpenPopup = (category) => {
    dispatch(openReellePopup(category));
    dispatch(
      openModal("add-writing-expression", { projectId: id, date: dataIndex })
    );
  };

  const openPopover = () => {
    const categoryToUse =
      category.category?.category ?? category?.category ?? category;

    if (isPlancompta) {
      handleOpenPopup({
        category: null,
        planComptaId: categoryToUse,
        dataIndex,
        isPlancompta,
      });
    } else {
      handleOpenPopup({
        category: categoryToUse,
        dataIndex,
        isPlancompta,
      });
    }
  };

  const onClose = () => {
    dispatch(openCreatePopOver(null));
    dispatch(handleHoverStatus(false));
  };

  useClickOutside([refCell], onClose);

  return (
    <div className="hover-Cell-wrapper" ref={refCell}>
      <div>
        <p>
          Ajouter une écriture{" "}
          {specialLabel}
        </p>
      </div>
      <div className="add-element-btn">
        <button id="add-btn" onClick={openPopover}>
          <img src={addEelement} alt="add-element" />
        </button>
      </div>
    </div>
  );
}

export default HoverCell;

export const InformationIcon = ({ text }) => {
  return (
    <Tooltip placement={"top"} title={text} trigger="hover">
      <div className="information-icon">i</div>
    </Tooltip>
  );
};
